module.exports = __webpack_public_path__ + "static/media/discount-icon.334994cc.png";